module.exports = __webpack_public_path__ + "img/5_AR-mb.6d3db789.png";